module.exports = __webpack_public_path__ + "static/media/stekker.887a4dd0.png";